import React, { Component } from 'react';
import Display from './Display.js';


class SettingsMenu extends React.Component {
  constructor(){
    super();
    this.state = {
      test:null,
    };
  }

  render() {
    var activeLEDOn = "led led-active-on";
    var strictLEDOn = "led led-strict-on";


    if (this.props.gameOver){
      return (    <div className="option-container">
                    <div className = "gameOver-menu">
                      <h4>Congrats</h4>
                      <p>You beat Simon in 15 rounds. To continue press the restart button!</p>
                      <div className="btn-container"><button className="btn restart-btn" onClick={this.props.restart}>                          </button>RESTART</div>
                    </div>
                  </div>);
    } else{

      var restartLabel = (this.props.gameStarted) ? "RESTART" : "START";
      return (
      <div className="option-container">
        <h3> Simon<sup className="small">&reg;</sup></h3>
        <div className="row-container">
          <div className={this.props.gameActive ? activeLEDOn : "led"}></div>
          <Display active={this.props.gameActive} error={this.props.error}>{this.props.round}</Display>
          <div className={this.props.strictMode ? strictLEDOn : "led"}></div>
        </div>
        <div className="row-container-two">
          <div className="btn-container"><button className="btn on-btn" onClick={this.props.toggleGame}></button>ON</div>
          <div className="btn-container"><button className="btn restart-btn" onClick={this.props.restart}></button>{restartLabel}</div>
          <div className="btn-container"><button className="btn hard-btn" onClick={this.props.toggleStrict}></button>STRICT</div>
        </div>
      </div>
      );
    }
  }
}

export default SettingsMenu;


// WEBPACK FOOTER //
// ./src/SettingsMenu.js